//accordion single
// window.addEventListener("load", () => {
//   let accordionElm = document.querySelectorAll(".js-acd-trigger");
//   let accordionElmArr = Array.prototype.slice.call(accordionElm);
//   let activeIndex = null;
//   accordionElmArr.forEach((accordion, index) => {
//     accordion.addEventListener("click", (e) => {
//       if (activeIndex !== null && activeIndex !== index) {
//         accordionElmArr[activeIndex].classList.remove("is-open");
//         accordionElmArr[activeIndex].nextElementSibling.style.maxHeight = null;
//       }
//       e.target.classList.toggle("is-open");

//       const panel = e.target.nextElementSibling;
//       if (panel.style.maxHeight) {
//         panel.style.maxHeight = null;
//       } else {
//         panel.style.maxHeight = panel.scrollHeight + "px";
//       }
//       activeIndex = index;
//     });
//   });
// });
window.addEventListener("load", function () {
  var accordionElm = document.querySelectorAll(".js-acd-trigger");
  var accordionElmArr = Array.prototype.slice.call(accordionElm);
  var activeIndex = null;
  accordionElmArr.forEach(function (accordion, index) {
    accordion.addEventListener("click", function (e) {
      if (activeIndex !== null && activeIndex !== index) {
        accordionElmArr[activeIndex].classList.remove("is-open");
        accordionElmArr[activeIndex]
          .closest(".o-faq_list")
          .classList.remove("is-open");
        accordionElmArr[activeIndex].nextElementSibling.style.maxHeight = null;
      }

      var obj = e.target;

      if (e.target !== e.currentTarget) {
        obj = e.target.closest("dt");
      }

      obj.classList.toggle("is-open");
      obj.closest(".o-faq_list").classList.toggle("is-open");
      var panel = obj.nextElementSibling;

      if (panel.style.maxHeight) {
        panel.style.maxHeight = null;
      } else {
        panel.style.maxHeight = panel.scrollHeight + "px";
      }

      activeIndex = index;
    });
  });
});

//accordion all
window.addEventListener("load", () => {
  let accordionElm = document.querySelectorAll(".js-acd-all-trigger");
  accordionElm.forEach((accordion) => {
    accordion.addEventListener("click", (e) => {
      e.target.classList.toggle("is-open");

      const panel = e.target.nextElementSibling;
      if (panel.style.maxHeight) {
        panel.style.maxHeight = null;
      } else {
        panel.style.maxHeight = panel.scrollHeight + "px";
      }
    });
  });
});

//accordion sp-menu
window.addEventListener("load", () => {
  let accordionElm = document.querySelectorAll(".js-menu-trigger");
  let activeIndex = null;
  accordionElm.forEach((accordion, index) => {
    accordion.addEventListener("click", (e) => {
      if (activeIndex !== null && activeIndex !== index) {
        accordionElm[activeIndex].classList.remove("is-open");
        accordionElm[activeIndex].nextElementSibling.classList.remove(
          "is-open"
        );
        accordionElm[activeIndex].nextElementSibling.style.minHeight = null;
      }
      e.target.classList.toggle("is-open");

      const panel = e.target.nextElementSibling;
      if (panel.style.minHeight) {
        panel.style.minHeight = null;
      } else {
        panel.style.minHeight = panel.scrollHeight + "px";
      }
      panel.classList.toggle("is-open");
      activeIndex = index;
    });
  });
});

//accordion mediaquery

window.addEventListener("load", () => {
  if (window.matchMedia("(max-width: 767px)").matches) {
    let accordionElm = document.querySelectorAll(".js-mq-acd-trigger");
    let accordionElmArr = Array.prototype.slice.call(accordionElm);
    let activeIndex = null;
    accordionElmArr.forEach((accordion, index) => {
      accordion.addEventListener("click", (e) => {
        if (activeIndex !== null && activeIndex !== index) {
          accordionElmArr[activeIndex].classList.remove("is-open");
          accordionElmArr[activeIndex].nextElementSibling.style.maxHeight =
            null;
        }
        e.target.classList.toggle("is-open");

        const panel = e.target.nextElementSibling;
        console.log(panel);
        if (panel.style.maxHeight) {
          panel.style.maxHeight = null;
        } else {
          panel.style.maxHeight = panel.scrollHeight + "px";
        }
        activeIndex = index;
      });
    });
  }
});
